"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MEASURES_UNDER_SALES_TAG = exports.SALES_COHORT_LEFTSIDE_EVENT_ID = void 0;
exports.isSalesCountEventOrMetricColumn = isSalesCountEventOrMetricColumn;
exports.isSalesRelatedMeasure = isSalesRelatedMeasure;
exports.isSalesCohortedColumn = isSalesCohortedColumn;
exports.isSalesRelatedMeasureCPA = isSalesRelatedMeasureCPA;
exports.isSalesLeftPanelMeasureId = isSalesLeftPanelMeasureId;
const dbTableCampaign_1 = require("../../reporterDb/dbTableCampaign");
const columnTypes_1 = require("./columnTypes");
/** Left-side measures list `eventId` for the Sales (Cohorted) chip; matches `useSalesMeasure`. */
exports.SALES_COHORT_LEFTSIDE_EVENT_ID = `${dbTableCampaign_1.Events.sales}_COHORT`;
exports.MEASURES_UNDER_SALES_TAG = [dbTableCampaign_1.Events.sales, dbTableCampaign_1.Metrics.cpa];
const isEventOrMetricColumn = (measure) => !measure.columnType ||
    [columnTypes_1.ColumnTypes.Event, columnTypes_1.ColumnTypes.Metric].includes(measure.columnType);
/**
 * Non-cohorted Event or Metric column for Sales **count** (not CPA).
 * Used e.g. for the left “Sales” chip selected state.
 */
function isSalesCountEventOrMetricColumn(measure) {
    if (!isEventOrMetricColumn(measure))
        return false;
    const resolvedEventId = measure.eventId ||
        measure.id;
    return resolvedEventId === dbTableCampaign_1.Events.sales;
}
/** orderedColumns item, already dropped in Measures strip: Sales count, Sales CPA, or Sales (Cohorted) (Count or CPA). */
function isSalesRelatedMeasure(measure) {
    const isCohortedColumn = measure.columnType === columnTypes_1.ColumnTypes.Cohorted;
    const eventId = isEventOrMetricColumn(measure)
        ? measure.eventId ||
            measure.id
        : isCohortedColumn
            ? measure.eventId
            : undefined;
    return (!!eventId &&
        exports.MEASURES_UNDER_SALES_TAG.includes(eventId));
}
/** Cohorted Sales in the measures row (Count or CPA). */
function isSalesCohortedColumn(measure) {
    return (measure.columnType === columnTypes_1.ColumnTypes.Cohorted &&
        isSalesRelatedMeasure(measure));
}
/** Synthetic `dataMappingId` / query column id: `{sales|cpa}_{CPA|Count}_{random}` (see useSalesMeasure). */
const SALES_SYNTHETIC_CPA_ID = /^(sales|cpa)_CPA_/i;
/**
 * Sales CPA column (non-count), including cohorted CPA children — for CSV `normalizeAs` / dollar formatting.
 * Accepts `getColumnsListByReportMeasures` rows (`eventId`, `id`, `columnType`) or `IOrderedColumn`.
 */
function isSalesRelatedMeasureCPA(column) {
    if (column.eventId === dbTableCampaign_1.Metrics.cpa)
        return true;
    const id = column.id;
    return !!id && SALES_SYNTHETIC_CPA_ID.test(id);
}
/** Left measures panel chip or drag payload: bare Sales or Sales (Cohorted). */
function isSalesLeftPanelMeasureId(eventId) {
    return eventId === dbTableCampaign_1.Events.sales || eventId === exports.SALES_COHORT_LEFTSIDE_EVENT_ID;
}
